module.exports = __webpack_public_path__ + "static/pwa-logo-ca1d4b338c7d45643d15414f6ea6a4ed.png";